import CompanyBody from './company_body.vue';

export default CompanyBody;
